<template>
    <ApplicationOverview />
</template>

<script>
import ApplicationOverview from '../components/ApplicationOverview.vue';

export default {
    name: 'ApplicationPage',
    components: {
        ApplicationOverview
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    mixins: [],
};
</script>
